import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { ExerciseDetailsFragment } from "@/gql/graphql";

import ExerciseField from "./ExerciseField";

interface Props {
  exercise: ExerciseDetailsFragment;
}

const Container = withStyles(Box, {
  root: {
    marginBlock: "24px",
  },
});

const ExerciseTypeText = withStyles(Typography, {
  root: {
    color: "#112340",
    fontWeight: 700,
    fontSize: 16,
  },
});

const MUIExerciseTabPanel: React.FC<Props> = ({ exercise }) => {
  return (
    <Container id={exercise.exerciseType.id}>
      <ExerciseTypeText>{exercise.exerciseType.name}</ExerciseTypeText>
      <Box height="16px" />
      <Grid container>
        {exercise.fields.map((e, key) => (
          <Grid item key={key} xs={3}>
            <ExerciseField
              label={e.label}
              value={e.numberValue}
              unit={getUnit(e.label, exercise)}
            />
          </Grid>
        ))}
        <Grid item xs={3}>
          <ExerciseField
            label="Duration"
            value={exercise.durationMinutes}
            unit="min"
          />
        </Grid>
        <Grid item xs={3} display="flex">
          <ExerciseField
            label="Calories burned"
            value={exercise.caloriesBurned}
            unit="kcal"
          />
        </Grid>
      </Grid>
    </Container>
  );
};

function getUnit(
  label: string,
  exercise: ExerciseDetailsFragment
): string | undefined {
  const field = exercise.fields?.find((f) => f.label === label);
  if (field && field.__typename === "ExerciseField") {
    return field.unit ?? undefined;
  }
  return undefined;
}

export default MUIExerciseTabPanel;
